import { render, staticRenderFns } from "./form-bmi.vue?vue&type=template&id=57c9080c&scoped=true"
import script from "./form-bmi.vue?vue&type=script&lang=js"
export * from "./form-bmi.vue?vue&type=script&lang=js"
import style0 from "./form-bmi.vue?vue&type=style&index=0&id=57c9080c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c9080c",
  null
  
)

export default component.exports